import { GridController, GridTable } from "@ctsu/ctsu-mui-grid";
import { getToken } from "@ctsu/loader";
import { a11y } from "components/common/NotificationCenter";
import { Pills, text } from "components/common/Text";
import useGetFromAppConfig, { useCurrentUser } from "helpers/getAppConfig";
import { clone, head } from "ramda";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import {
  fetchPersonRoleNameLov,
  fetchRegistrationTypes,
  saveSelectedRow,
  setIsEditingFlag
} from "stores/redux/slice/personRoleSetup";

import CopyRow from "./CopyRow";
import PersonRoleNameLov from "./PersonRoleNameLov";




const yesNo = [
  {
    label: text("common.yes"),
    value: true
  },
  {
    label: text("common.no"),
    value: false
  }
];
export function CommaToPills({ data }) {
  if (data) {
    const content = data.split(",");
    return (
      <ul className="list-nostyle">
        {content.map((t) => (
          <li key={t} className="my-1">
            <Pills text={t} />
          </li>
        ))}
      </ul>
    );
  }
}

const renderYN = (rowData, key) => {
  if (rowData[key] === "") {
    return "";
  } else if (rowData[key] === true) {
    return "Yes";
  } else {
    return "No";
  }
};

export default function RoleSetup({ data, rosterOwnerLov, hasEditPermission }) {
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const objectTypeLov = useGetFromAppConfig("LOV_PERSON_ROLES_SETUP_OBJECT_TYPE", "objectType");
  const roleTypeLov = useGetFromAppConfig("LOV_PERSON_ROLES_SETUP_ROLE_TYPE", "roleType");
  const selectedOwnerRef = useRef(null)



  const containerRef = useRef(null);
  const gridController = useRef(GridController.createController());

  const columns = [
    {
      filter: true,
      label: "Roster Owner",
      name: "owner",
      options: clone(rosterOwnerLov),
      type: "object",
      title: "Roster Owner"
    },
    {
      filter: true,
      label: "Role Name",
      name: "personRoleName",
      title: "Role Name",
      type: "custom-list",
      renderCustomFilter: () => (
        <PersonRoleNameLov name="personRoleName" label="Role Name" gridController={gridController} />
      )

    },
    {
      filter: true,
      label: "For Object Type",
      name: "objectType",
      title: "For Object Type",
      showWhitespace: true,
      valueType: "commaSeparated",
      type: 'object',
      renderCell: rowData => <CommaToPills data={rowData.forObjectType} />,
      options: Array.isArray(objectTypeLov) ? [...objectTypeLov, { label: "    ", value: "NULL" }] : [],
    },

    {
      filter: true,
      label: "Role Type",
      name: "personRoleType",
      title: "Role Type",
      options: roleTypeLov.filter(x => x.label !== "All"),
      type: "object"
    },
    {
      filter: true,
      label: "Site Main",
      name: "siteMain",
      options: yesNo,
      title: "Site Main",
      type: "object",
      renderCell: rowData => renderYN(rowData, "siteMain"),
      exportAsYesNo: true
    },
    {
      filter: true,
      label: "Delete Allowed",
      name: "deleteAllowed",
      options: yesNo,
      title: "Delete Allowed",
      type: "object",
      renderCell: rowData => renderYN(rowData, "deleteAllowed"),
      exportAsYesNo: true
    },
    {
      filter: true,
      label: "Admin Priv",
      name: "adminPriv",
      options: yesNo,
      title: "Admin Priv",
      type: "object",
      renderCell: rowData => renderYN(rowData, "adminPriv"),
      exportAsYesNo: true
    },
    {
      filter: true,
      label: "Regtype Check",
      name: "regTypeCheck",
      options: yesNo,
      title: "Regtype Check",
      renderCell: rowData => renderYN(rowData, "regTypeCheck"),
      exportAsYesNo: true,
      type: "object"
    },
    {
      filter: true,
      label: "Primary Contact",
      name: "primaryContact",
      options: yesNo,
      renderCell: rowData => renderYN(rowData, "primaryContact"),
      exportAsYesNo: true,
      title: "Primary Contact",
      type: "object"
    },
    {
      filter: true,
      label: "Esys Status",
      name: "esysStatus",
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" }
      ],
      title: "Esys Status",
      type: "object"
    },
    {
      filter: true,
      label: "Rave EDC Role",
      name: "raveEDCRole",
      title: "Rave EDC Role",
      visible: false
    },
    {
      filter: true,
      label: "CTSU Role",
      name: "ctsuRole",
      title: "CTSU Role",
      visible: false
    },
    {
      filter: true,
      label: "Grp Ref Code",
      name: "grpRefCode",
      title: "Grp Ref Code",
      visible: false
    },
    {
      filter: true,
      label: "Max Assign",
      name: "maxAssign",
      title: "Max Assign",
      visible: false
    },
    {
      filter: true,
      label: "OGN Req",
      name: "ognReq",
      title: "OGN Req",
      visible: false,
      exportAsYesNo: true,

    }

  ];
  return (
    <section className={`person-roles-setup-grid `}>
      <GridTable
        user={currentUser}
        controller={gridController.current}
        id="personRoleEnumId"
        rows={data}
        title="Person Roles Setup"
        columns={columns}
        toPdf={false}
        filterable
        enableInfiniteScroll={false}
        sortable
        showFilterByDefault
        addRowLabel="Role"
        addRowTitle="Add role"
        enableToolbar
        highlightRow={0}
        recordPerPage={10}
        getToken={getToken}
        tag="person-role-setup-browser"
        editMode={hasEditPermission}
        editable
        allowAddRow
        rowEditable={() => true}
        preventRowClickOnEdit
        allowCopyRow={() => true}
        generateToolTip={(row, type) =>
          `${type} the ${row.personRoleName} role
for ${row.owner}`}
        renderEditRow={(row) => (
          <CopyRow row={row} columns={columns} containerRef={containerRef} controller={gridController.current} rosterOwnerLov={rosterOwnerLov} />
        )}
        onDataLoad={(res) => {
          if (res && res.data) {
            let selected = head(res.data || {});
            dispatch(saveSelectedRow(selected));
            dispatch(setIsEditingFlag(false));
            if (selected && selected.personRoleEnumId) {
              dispatch(fetchRegistrationTypes({ personRoleEnumId: selected.personRoleEnumId }));
            }
          }
        }}
        onFilter={(_, f) => {
          if (f && f.field === "owner" && f.value !== selectedOwnerRef.current) {
            dispatch(fetchPersonRoleNameLov(f.value));
            selectedOwnerRef.current = f.value

          }
        }}
        onRowClicked={(rowData) => {
          dispatch(saveSelectedRow(rowData));
          dispatch(fetchRegistrationTypes({ personRoleEnumId: rowData.personRoleEnumId }));
          dispatch(setIsEditingFlag(false));
          a11y.triggerAlertMessage(`Role type of id ${rowData.personRoleEnumId} is now selected`);
        }}
      />
    </section>
  );
}
